import React from 'react';
import { Button, Row, Col, Typography } from 'antd';
import { WhatsAppOutlined, EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { sendGAEvent } from '../../utils';

const { Title, Paragraph } = Typography;

interface HeroBannerProps {
    className?: string;
}

const companyLogos = [
    { name: 'Grupo Boticário', width: 140 },
    { name: 'Netshoes', width: 110 },
    { name: 'SPC Brasil', width: 90 },
    { name: 'Indra', width: 80 },
    { name: 'Pmweb', width: 90 },
];

const HeroBanner: React.FC<HeroBannerProps> = ({ className }) => {

    return (
        <section
            className={className}
            style={{
                background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                padding: 'clamp(32px, 8vw, 80px) 0 clamp(40px, 8vw, 60px) 0',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            {/* Background Pattern */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    opacity: 0.03,
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='3'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                }}
            />

            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                padding: '0 clamp(16px, 4vw, 24px)',
                position: 'relative',
                zIndex: 1
            }}>
                <Row justify="center" align="middle">
                    <Col xs={24} lg={20} xl={18}>

                        {/* Main Title */}
                        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                            <Title
                                level={1}
                                style={{
                                    fontSize: 'clamp(2rem, 4vw, 3.5rem)',
                                    fontWeight: 800,
                                    lineHeight: 1.2,
                                    marginBottom: '24px',
                                    background: 'linear-gradient(135deg, #1e40af, #3b82f6)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    backgroundClip: 'text'
                                }}
                            >
                                Arquitetura Frontend escalável e liderança técnica
                            </Title>

                            {/* Subtitle */}
                            <Paragraph
                                style={{
                                    fontSize: 'clamp(1.125rem, 2vw, 1.375rem)',
                                    color: '#475569',
                                    lineHeight: 1.6,
                                    maxWidth: '800px',
                                    margin: '0 auto 40px auto',
                                    fontWeight: 500
                                }}
                            >
                                <span style={{ fontWeight: 700, color: '#334155' }}>
                                    Staff Engineer
                                </span> com ampla experiência em e-commerce de grande escala e plataformas enterprise.
                                <br />
                                Especialista em React, Node.js e arquiteturas de alta performance que atendem milhões de usuários.
                            </Paragraph>
                        </div>

                        {/* CTA Buttons */}
                        <div style={{ textAlign: 'center', marginBottom: 'clamp(40px, 8vw, 64px)' }}>
                            <Row gutter={[16, 16]} justify="center">
                                <Col xs={24} sm={12} md={10} lg={8}>
                                    <Button
                                        type="primary"
                                        size="large"
                                        icon={<WhatsAppOutlined />}
                                        block
                                        onClick={() => {
                                            sendGAEvent("click_hero_contact_urgent", {
                                                location: "hero_banner",
                                                label: "Contato Urgente"
                                            });
                                            window.open('https://wa.me/5511944487679?text=Olá Silvano! Vi seu site e preciso conversar sobre um projeto urgente de frontend/liderança técnica.', '_blank');
                                        }}
                                        style={{
                                            background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                                            borderColor: 'transparent',
                                            height: '56px',
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            borderRadius: '12px',
                                            boxShadow: '0 8px 25px rgba(37, 99, 235, 0.3)',
                                            transition: 'all 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 12px 35px rgba(37, 99, 235, 0.4)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(37, 99, 235, 0.3)';
                                        }}
                                    >
                                        Vamos Conversar
                                    </Button>
                                </Col>
                                <Col xs={24} sm={12} md={10} lg={8}>
                                    <Link to="/perfil" style={{ display: 'block' }}>
                                        <Button
                                            size="large"
                                            icon={<EyeOutlined />}
                                            block
                                            onClick={() =>
                                                sendGAEvent("click_hero_portfolio", {
                                                    location: "hero_banner",
                                                    label: "Ver Portfólio"
                                                })
                                            }
                                            style={{
                                                height: '56px',
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                borderRadius: '12px',
                                                borderWidth: '2px',
                                                borderColor: '#3b82f6',
                                                color: '#3b82f6',
                                                background: 'transparent',
                                                transition: 'all 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = '#3b82f6';
                                                e.currentTarget.style.color = '#ffffff';
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = 'transparent';
                                                e.currentTarget.style.color = '#3b82f6';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                            }}
                                        >
                                            Conheça Minha Experiência
                                        </Button>
                                    </Link>
                                </Col>
                            </Row>
                        </div>

                        {/* Company Logos Section */}
                        <div style={{ textAlign: 'center' }}>
                            <Paragraph
                                style={{
                                    fontSize: '14px',
                                    color: '#64748b',
                                    marginBottom: '32px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px',
                                    fontWeight: 600
                                }}
                            >
                                Experiência em empresas líderes de mercado
                            </Paragraph>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: 'clamp(16px, 4vw, 32px)',
                                filter: 'grayscale(100%)',
                                opacity: 0.6,
                                transition: 'opacity 0.3s ease',
                                padding: '0 16px'
                            }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = '0.6'}
                            >
                                {companyLogos.map((company, index) => (
                                    <div
                                        key={company.name}
                                        style={{
                                            width: `clamp(${Math.max(company.width * 0.7, 80)}px, ${company.width * 0.8}px, ${company.width}px)`,
                                            height: 'clamp(40px, 5vw, 48px)',
                                            background: '#f1f5f9',
                                            border: '2px solid #e2e8f0',
                                            borderRadius: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: 'clamp(10px, 2.5vw, 12px)',
                                            fontWeight: 600,
                                            color: '#475569',
                                            transition: 'all 0.3s ease',
                                            cursor: 'default'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#3b82f6';
                                            e.currentTarget.style.background = '#eff6ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = '#e2e8f0';
                                            e.currentTarget.style.background = '#f1f5f9';
                                        }}
                                    >
                                        {company.name}
                                    </div>
                                ))}
                            </div>
                        </div>

                    </Col>
                </Row>
            </div>
        </section>
    );
};

export default HeroBanner;